import React, { ChangeEvent, FC, KeyboardEvent, useState } from 'react';
import { Chip, TextField, TextFieldProps } from '@mui/material';
import { Controller, get, useFormContext } from 'react-hook-form';
import {
  ChipsContainer,
  MultiValueFormControl,
} from 'src/components/Forms/FormInputs/styled';

interface MultiValueInputProps {
  name: string;
}

export const MultiValueInput: FC<MultiValueInputProps & TextFieldProps> = ({
  name,
  ...props
}) => {
  const [currValue, setCurrValue] = useState('');
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = get(errors, name);

  const handleDelete = (
    index: number,
    value: string[],
    onChange: (value: string[]) => void,
  ) => {
    const newValue = value.filter((_, i) => i !== index);
    onChange(newValue);
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setCurrValue(event.target.value);
  };

  const handleKeyUp = (
    e: KeyboardEvent<HTMLDivElement>,
    value: string[],
    onChange: (value: string[]) => void,
  ) => {
    if (e.key === 'Enter' && currValue.trim() !== '') {
      const newValue = [...value, currValue];
      setCurrValue('');
      onChange(newValue);
    }
  };

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <MultiValueFormControl error={!!error?.message}>
          <ChipsContainer>
            {value.map((item: string, index: number) => (
              <Chip
                key={index}
                size="small"
                variant="outlined"
                label={item}
                onDelete={() => handleDelete(index, value, onChange)}
              />
            ))}
            <TextField
              {...props}
              placeholder="Enter values"
              autoComplete="off"
              value={currValue}
              onChange={handleChange}
              onKeyUp={(event) => handleKeyUp(event, value, onChange)}
            />
          </ChipsContainer>
        </MultiValueFormControl>
      )}
    />
  );
};
